__turbopack_context__.v({
  "combineFeeds": "Feed-module-scss-module__z6GbOG__combineFeeds",
  "feed": "Feed-module-scss-module__z6GbOG__feed",
  "feedContainer": "Feed-module-scss-module__z6GbOG__feedContainer",
  "firstFeed": "Feed-module-scss-module__z6GbOG__firstFeed",
  "listHeader": "Feed-module-scss-module__z6GbOG__listHeader",
  "listHeaderSmall": "Feed-module-scss-module__z6GbOG__listHeaderSmall",
  "listTitle": "Feed-module-scss-module__z6GbOG__listTitle",
  "withWidescreenAd": "Feed-module-scss-module__z6GbOG__withWidescreenAd",
});
